import { PROJECT_ID_KEY } from '@editor/global/constants';

import monitoring from '../services/monitoring';

export const setItemJsonStringified = <T>(key: string, value: T): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    monitoring.captureException(error);
  }
};

export const getItemAndParseJsonString = <T>(key: string): T | null => {
  try {
    const storedValue = localStorage.getItem(key);
    if (storedValue) {
      return JSON.parse(storedValue);
    }
    return null;
  } catch (error) {
    monitoring.captureException(error);
  }
  return null;
};

// we need to store the "most recently viewed" project id for
// each workspace the user access
// the following functions are just helper utils to store and retrieve this value

/**
 * Store a project id in local storage for a specific workspace ID
 * @param workspaceId string - the value of the workspace ID
 * @param projectId string - the value of the project ID
 */
export const setProjectIdInLocalStorageForWorkspace = (
  workspaceId: string,
  projectId: string
): void => {
  // we set both so we always have a "global latest" as well
  localStorage.setItem(PROJECT_ID_KEY, projectId);
  localStorage.setItem(`${PROJECT_ID_KEY}_${workspaceId}`, projectId);
};

/**
 * retrieve a project id from local storage for a specific workspace ID
 * @param workspaceId string - the value of the workspace ID
 * @returns the project ID most recently viewed for this workspace, or null if it doesn't exist
 */
export const getProjectIdFromLocalStorageForWorkspace = (
  workspaceId: string
): string | null => {
  return localStorage.getItem(`${PROJECT_ID_KEY}_${workspaceId}`);
};

/**
 * A helper function to clear all project IDs from local storage
 * by clearing by key prefix
 */
export const clearAllWorkspaceProjectIdsFromLocalStorage = (): void => {
  for (const key in localStorage) {
    if (key.startsWith(PROJECT_ID_KEY)) {
      localStorage.removeItem(key);
    }
  }
  // clear the legacy key as well just in case
  localStorage.removeItem(PROJECT_ID_KEY);
};
